import React from 'react'
import { useSelector } from 'react-redux'
import ReactHtmlParser from 'react-html-parser';
export const Description = () => {
    const data = useSelector((state) => state.productDetailsInfo.data.productInfo)
  return (
    <div>{ ReactHtmlParser (data.Description?data.Description:data.description)}</div>
  )
}
